function generateMembership(devPort, userName, managerMode, setCurrentMembership) {
  const body = {
    username: userName,
    is_new_player: managerMode !== -1,
    is_new_manager: managerMode === -1,
  };
  return fetch(devPort + "system_add_membership", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log("User ID has been set");
      if (managerMode !== -1) {
        setCurrentMembership("player");
      }
    });
}

export default generateMembership;
